import { Fragment } from 'react';
import axios, { post } from 'axios';
import cookie from 'react-cookies';
import { API } from '../../settings/api';
import { HOST } from '../../settings/host';
import twoDigitFormat from '../../scripts/helpers/two.digit.format';

export async function all( store, reload = false ) {

  try {

    const token = cookie.load(`token`);
    const { status, data } = await post( API.user.all, { token } );

    console.log(`companies.All data:`, data);

    if ( status === 200 ) {

      if ( data.success ) {

        const companiesList = data.users.map( user => {
          
          const created_at_date = new Date( user.created_at );
          const created_at = `${ twoDigitFormat( created_at_date.getDate() ) }.${ twoDigitFormat( created_at_date.getMonth() + 1 ) }.${ created_at_date.getFullYear() } ${ twoDigitFormat( created_at_date.getHours() ) }:${ twoDigitFormat( created_at_date.getMinutes() ) }`;

          return ({

            ...user,
            created_at,

          })
        
        });

        store.setState({
          companiesList
        });

        reload();
        
      } else {

        throw( data.text );

      }

    } else {

      throw('Нет соединения с сервером');

    }

  } catch ( err ) {

    console.error( err );
    // showError( err );

  }
  
}

export async function get( store, id, reload = false ) {

  try {

    const token = cookie.load(`token`);
    const { status, data } = await post( API.user.get, { user_id: id, token } );

    console.log(`companies.get data:`, data);

    if ( status !== 200 || !data?.success) { throw( data.text ); }

    let { user } = data;

    store.setState({

      user: {

        ...user,
        id: id

      },

      subscribe: data.subscribe

    });

    reload && reload();

  } catch ( err ) {

    console.error( err );
    // showError( err );

  }
  
}

export async function add( store, obj = {} ) {

  try {

    const token = cookie.load(`token`);

    const { status, data } = await post( API.user.add, { token, ...obj } );

    console.log(`companies.add data:`, data);

    if ( status !== 200 || !data?.success) { throw( data.error ); }

    store.actions.users.clearCompanyStates();

    setTimeout(() => {

      store.actions.users.all();
      window.location = "/companies";

    }, 1000);

  } catch ( err ) {

    console.error( err );

  }
  
}

export async function remove( store, id ) {

  try {

    if ( !window.confirm(`Вы действительно хотите навсегда удалить франшизу, все её настройки, всех её сотрудников, и все её чертежи балконов? Это действие необратимо!`) ) { return; }

    const token = cookie.load(`token`);

    const { status, data } = await post( API.companies.remove, { id }, { headers: { token } } );

    console.log(`companies.remove data:`, data);

    if ( status !== 200 || !data?.success) { throw( data.text ); }

    store.actions.companies.clearCompanyStates();
    window.location = "/companies";

  } catch ( err ) {

    console.error( err );

  }
  
}

export async function changeInfo( store, id, obj = {}, reload = false ) {

  try {

    const token = cookie.load(`token`);

    const params = { 

      id,
      ...obj

    }

    const { status, data } = await post( API.user.edit, { token, ...params });

    console.log(`users.changeInfo data:`, data);

    if ( status !== 200 || !data?.success) { throw( data.error ); }

    let newState = { 

      user: { 

        ...store.state.user,
        active: obj.active 

      } 
      
    }

    store.setState( newState );

    setTimeout(() => {
      store.actions.users.get( id );
    }, 1000);

    reload && reload(); //!

  } catch ( err ) {

    console.error( err );
    // showError( err );

  }
  
}

export async function clearCompanyStates( store ) {

  store.setState({

    user: {

      id: "",
      company_name: "",
      comment: "",
      fio: "",
      email: "",
      phone: "",
      created_at: "",
      active: 1,

    },
    
  });

}